<script setup lang="ts">
import DialogFooter from "@/stories/dialogs/DialogFooter.vue";
</script>

<template>
  <DialogFooter>
    <div
      :class="[
        'grid grid-cols-2 gap-4',
        'tablet:flex tablet:justify-end tablet:gap-2 tablet:items-center',
        '[&>*]:w-full [&>*]:laptop:w-auto',
      ]"
    >
      <div v-if="$slots.left" class="grow flex items-center">
        <slot name="left"></slot>
      </div>
      <slot></slot>
    </div>
  </DialogFooter>
</template>
